export { addMedia, addMediaImage } from './api';
